import emailjs from '@emailjs/browser'

export const CONTACT_EMAIL = 'thedeverseagency@gmail.com'

export const EMAILJS = {
  serviceId: import.meta.env.VITE_EMAILJS_SERVICE_ID || 'service_ut3mdm5',
  contactTemplateId:
    import.meta.env.VITE_EMAILJS_CONTACT_TEMPLATE_ID || 'template_s2hgt7s',
  demoTemplateId: import.meta.env.VITE_EMAILJS_DEMO_TEMPLATE_ID || 'template_mf00j6f',
  publicKey: import.meta.env.VITE_EMAILJS_PUBLIC_KEY || 'asBSBNcs_muuBTcS1',
}

export async function sendContactEmail({ name, email, subject, message }) {
  return emailjs.send(
    EMAILJS.serviceId,
    EMAILJS.contactTemplateId,
    {
      from_name: name,
      reply_to: email,
      subject: subject || 'Contact — Deverse',
      message,
    },
    EMAILJS.publicKey
  )
}

export async function sendDemoEmail({ name, email, business, phone, message }) {
  return emailjs.send(
    EMAILJS.serviceId,
    EMAILJS.demoTemplateId,
    {
      from_name: name,
      reply_to: email,
      business,
      phone: phone || '—',
      message: message || '—',
    },
    EMAILJS.publicKey
  )
}
